import { Injectable } from '@angular/core';

export enum ACCESS_VERSION {
    BASIC = 'basic',
    NORMAL = 'normal',
    PLUS = 'plus',
}

@Injectable({
    providedIn: 'root'
})
export class AccessService {
    isPlus(version: ACCESS_VERSION): boolean {
        return version === ACCESS_VERSION.PLUS;
    }

    isBasic(version: ACCESS_VERSION): boolean {
        return version === ACCESS_VERSION.BASIC;
    }

    isNormal(version: ACCESS_VERSION): boolean {
        return version === ACCESS_VERSION.NORMAL;
    }
}